import * as React from 'react';
import {Col, Container, Row} from 'reactstrap';
import MiranaServiceClient from '../../../../middleware/mirana-client';
import {lazyInject, TYPES} from '../../../../utils/inversify-config';
import {connect} from 'react-redux';
import {mirana} from '@wize/mirana-proto/mirana-proto';
import AvanceAnualForm from './avance-anual-form';
import AvanceAnualTable from './avance-anual-table';
import {error, success} from '../../../../utils/notification-actions';
import {getFileName} from '../../../../utils/utils';
import fileDownload from 'js-file-download';

interface ComparativoState {
    data?: mirana.AvanceAnualList;
    categorias: string[];
    lineas: string[];
}

class AvanceAnual extends React.PureComponent<ReduxProps, ComparativoState> {

    constructor(props) {
        super(props);
        this.state = {
            lineas: [],
            categorias: []
        };
    }

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    public handleFiltrar = async (values) => {
        try {
            const categorias: string[] = [];
            if (values.categorias) {
                values.categorias.forEach((opt) => {
                        categorias.push(opt.value);
                    }
                )
            }
            const lineas: string[] = [];
            if (values.lineas) {
                values.lineas.forEach((opt) => {
                        lineas.push(opt.value);
                    }
                )
            }
            const response = await this.apiClient.filtrarAvanceAnual(categorias, lineas);
            this.setState({data: response, lineas, categorias});
            this.props.dispatch(success('Notificación', `Avances anuales correctamente filtrados`));
        } catch (ex) {
            this.props.dispatch(error('Error', 'Error interno al filtrar coberturas'));
        }
    };

    private handleDescargar = async () => {
        const {lineas, categorias} = this.state;
        const response = await this.apiClient.descargarAvanceAnual(categorias, lineas);
        fileDownload(response.data, getFileName(response));
    };

    public render() {
        return (
            <Container>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>Avances: Comparativo Anual</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <AvanceAnualForm onSubmit={this.handleFiltrar}/>
                    </Col>
                    <Col md={9}>
                        <AvanceAnualTable data={this.state.data} handleDescargar={this.handleDescargar}/>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default connect()(AvanceAnual);



// WEBPACK FOOTER //
// ./src/components/pages/avance/anual/avance-anual.tsx